export default class TableCreationRequest {
    tableName: string

    constructor(tableName: string) {
        this.tableName = tableName;
    }
}